export { default as ReactPhotoCollage } from './react-photo-collage/react-photo-collage-container';